<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-3 white--text"
        color="hrissecondary"
        :loading="progressing"
        :disabled="employees.length <= 0"
        v-on="on"
      >
        Release
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Release EA form"
      text="Release EA form for the selected year and companies"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="8">
              <v-card class="pa-4 elevation-5">
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="filteredHeaders"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  show-select
                  class="elevation-1 mb-3"
                  height="272px"
                  :error-messages="errors.collect('selectedEmployees')"
                  data-vv-name="selectedEmployees"
                  data-vv-as="employee selection"
                >        
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar
                        flat
                        color="white"
                      >
                        <v-toolbar-title>Employee Selection:</v-toolbar-title>
                      </v-toolbar>
                      <v-col cols="5">
                        <div
                          class="mt-1 pr-1"
                          style="display: flex; justify-content: flex-end"
                        >
                          <v-switch
                            v-model="isReleased"
                            label="Is EA released"
                            @change="selectedEmployees = []"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                  
                  <template v-slot:item.is_released="{ item }">
                    <v-icon medium>
                      {{ item.is_released ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                    </v-icon>
                  </template>
                  
                  <template v-slot:item.is_email_sent="{ item }">
                    <v-icon medium>
                      {{ item.is_email_sent ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                    </v-icon>
                  </template>
                </v-data-table>
                
                <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                  <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
                </div>
              </v-card>
            </v-col>
            
            <v-col cols="4">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee"
                hide-no-data
                hide-selected
              />
              <v-row v-if="!isReleased">
                <v-menu
                  v-model="releaseDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="releaseDateDisplay"
                      v-validate="'required'"
                      label="Release Date"
                      :error-messages="errors.collect('releaseDateDisplay')"
                      data-vv-name="releaseDateDisplay"  
                      data-vv-as="release date"    
                      readonly
                      class="label-position"
                      v-on="on"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon>
                          mdi-calendar
                        </v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="releaseDate"
                    @input="releaseDateMenu = false"
                  />
                </v-menu>
              </v-row>

              <v-card-actions style="position: absolute;bottom: 30px;right: 0px;">
                <v-spacer />
                <v-btn
                  :disabled="progressing"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  v-if="isReleased"
                  :loading="progressing && isEmail"
                  :disabled="progressing && isWithdraw"
                  color="purple"
                  class="white--text px-3"
                  @click="validate"
                >
                  Email EA Form
                </v-btn>
                <v-btn
                  v-if="isReleased"
                  :loading="progressing && isWithdraw"
                  :disabled="progressing && isEmail"
                  color="red"
                  class="white--text px-3"
                  @click="withdraw"
                >
                  Cancel Released EA Form
                </v-btn>
                <v-btn
                  v-if="!isReleased"
                  :loading="progressing"
                  color="hrissecondary"
                  class="white--text px-10"
                  @click="submitForm"
                >
                  Release EA Form
                </v-btn>
              </v-card-actions>
              <payroll-dialog-email
                ref="showEmailWindow"
                :document-type="'EA Form'"
                @emailed="loadData();selectedEmployees = []"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      PayrollDialogEmail: () => import('@/components/hris/payroll/DialogEmail'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employees: {
        type: Array,
        required: true,
      },
      companies: {
        type: Array,
        required: true,
      },
      selectedCompanies: {
        type: Array,
        required: true,
      },
      selectedYear: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data () {
      return {
        isWithdraw: false,
        isEmail: false,
        dialog: false,
        progressing: false,
        selectedEmployees: [],        
        switchEmployees: [],
        loadedCompanyEmployees: [],
        companyEmployeeUids: [],
        tableLoading: false,
        searchInput: '',
        empObj: null,
        isReleased: 0, 
        releaseDate: null,
        releaseDateMenu: false,
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company_name',
          }, 
          {
            text: 'Released?',
            align: 'center',
            sortable: false,
            value: 'is_released',
          },
        ],
      }
    },

    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.switchEmployees.filter(function (employee) {
          return ((employee || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })

        return primaryFilterEmployees
      },
      filteredHeaders () {
        return this.isReleased ? [...this.headers, {
          text: 'Email Sent?',
          align: 'center',
          sortable: false,
          value: 'is_email_sent',
        },
        ] : this.headers
      },
      releaseDateDisplay () {
        return this.releaseDate ? this.$moment(this.releaseDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        
        this.loadData()
      },
      isReleased: {
        immediate: true,
        handler (value) {
          if (this.dialog) {
            this.switchEmployees = []
            
            if (this.isReleased) { 
              this.isReleased = 1 
              
              this.switchEmployees = this.orderedEmployees.filter(emp => {
                return emp.is_released === 1
              })
            } else { 
              this.isReleased = 0
              
              this.switchEmployees = this.orderedEmployees.filter(emp => {
                return emp.is_released === 0
              })
            }
          }
        },
      },    
    }, 

    methods: {
      loadData () {
        this.orderedEmployees = []
        this.loadedCompanyEmployees = []
        this.tableLoading = true

        this.employees.forEach(employee => {
          this.companyEmployeeUids.push(employee.company_employee_uid)
        })

        this.$api.companyEmployeeDocuments().list({ year: this.selectedYear, companyEmployeeUids: this.companyEmployeeUids })
          .then((res) => {
            res.data.map(emp => {
              this.empObj = {
                company_employee_uid: emp.company_employee_uid,
                name: emp.employee.person.name,
                company_uid: emp.company.id,
                company_name: emp.company.name,
                company_employee_documents: emp.company_employee_documents,
                is_released: emp.company_employee_documents.length > 0 ? 1 : 0,
                is_email_sent: emp.company_employee_documents.length > 0 && emp.company_employee_documents[0].is_email_sent === 1 ? 1 : 0,
                start_date: emp.start_date,
                end_date: emp.end_date,
              }
              this.loadedCompanyEmployees.push(this.empObj)
            })

            this.orderedEmployees = _.orderBy(this.loadedCompanyEmployees, ['name', 'start_date'], ['asc', 'desc'])

            this.orderedEmployees = this.orderedEmployees.filter((e, i) => {
              return this.orderedEmployees.findIndex((x) => {
                return x.name === e.name && x.company_uid === e.company_uid && (x.end_date && e.end_date === this.$moment(x.start_date).add(1, 'days') ? e.end_date === this.$moment(x.start_date).add(1, 'days') : x.end_date ? x.end_date : x.end_date === null)
              }) === i
            })

            this.switchEmployees = this.orderedEmployees.filter(emp => {
              return emp.is_released === this.isReleased
            })
            this.tableLoading = false
          })
      },
      validate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.$refs.showEmailWindow.toggleDialog(this.prepareSelectedEmployeesFormData())
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollReports().releaseEmployeeEa(this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'EA form released successfully' })
                this.loadData()
                this.selectedEmployees = []
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                } else this.$snack({ color: 'error', message: 'Unable to release EA' })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      withdraw () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.isWithdraw = true

            this.$api.payrollReports().withdrawEmployeeEa(this.prepareSelectedEmployeesFormData())
              .then(res => {
                this.$snack({ message: 'EA form withdrawn successfully' })
                this.loadData()
                this.selectedEmployees = []
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                } else this.$snack({ color: 'error', message: 'Unable to withdraw sent EA' })
              })
              .then(() => {
                this.progressing = false
                this.isWithdraw = false
              })
          })
      },
      prepareFormData () {
        return {
          date: this.releaseDate,
          year: this.selectedYear,
          selectedCompanyEmployees: this.selectedEmployees,
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies }
      },       
      prepareSelectedEmployeesFormData () {
        return {
          year: this.selectedYear,
          selectedCompanyEmployees: this.selectedEmployees,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
.cursor-pointer >>> tr{
  cursor: pointer;
}
</style>
